import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import styled from "styled-components";
import { motion } from "framer-motion";
import { useLocation, useNavigate } from "react-router-dom";

export default function EventsVideo({ slides }) {

  console.log("slides", slides)
  const settings = {
    infinite: true,
    speed: 900,
    slidesToShow: 1,
    centerMode: true,
    centerPadding: "20%",
    arrows: false,
    autoplay: true,
    autoplaySpeed: 4000,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          centerMode: false,
          centerPadding: "0",
        },
      },
    ],
  };

  return (
    <div className="sectionPadding">

      <Wrapper className="">
        <SliderWrapper>
          <Slider {...settings}>
            {slides.map((item, i) => (
              <SlideItem key={i} item={item} />
            ))}
          </Slider>
        </SliderWrapper>
      </Wrapper>
    </div>
  );
}
function SlideItem({ item }) {
  const navigate = useNavigate();
  const location = useLocation();

  const [videoError, setVideoError] = useState(false);
  const [videoLoaded, setVideoLoaded] = useState(false);

  const isMobile = window.innerWidth <= 768;

  const banner = isMobile ? item.mobileBanner : item.banner;

  const videoUrl = banner?.video?.url;
  const imageUrl = banner?.image?.url;

  const shouldShowVideo = videoUrl && !videoError;

  const formatTitleForUrl = (title) =>
    title
      .toLowerCase()
      .trim()
      .replace(/&/g, "and")
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/-+/g, "-")
      .replace(/^-|-$/g, "");

  useEffect(() => {
    if (location.hash) {
      const id = location.hash.replace("#", "");
      const el = document.getElementById(id);

      if (el) {
        setTimeout(() => {
          el.scrollIntoView({
            behavior: "smooth",
            block: "start",
          });
        }, 300);
      }
    }
  }, [location]);

  return (
    <Slide>

      {imageUrl && (
        <Image
          style={{
            backgroundImage: `url(${imageUrl})`,
            opacity: shouldShowVideo && videoLoaded ? 0 : 1,
          }}
        />
      )}

      {shouldShowVideo && (
        <Video
          src={videoUrl}
          autoPlay
          muted
          loop
          playsInline
          onCanPlay={() => setVideoLoaded(true)}
          onError={() => setVideoError(true)}   // fallback trigger
          style={{ opacity: videoLoaded ? 1 : 0 }}
        />
      )}

      <Overlay />

      <Content
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
      >
        <Title>{item.title}</Title>
        <Desc>{item.desc}</Desc>
      </Content>

      <Explore
        onClick={() =>
          navigate(`/events#${formatTitleForUrl(item.title)}`)
        }
      >
        explore →
      </Explore>
    </Slide>
  );
}

const Wrapper = styled.div`
  width: 100%;

  display: flex;
  align-items: center;
`;

const SliderWrapper = styled.div`
  width: 100%;

  .slick-slide {
    padding: 0 16px;
  }
      .slick-list {
    padding: 0 !important;
  }
`;

const Slide = styled.div`
  position: relative;
  height: 75vh;
  background: #000;
  border-radius: 24px;
  overflow: hidden;
  
`;

const Image = styled.div`
  position: absolute;
  inset: 0;
  background-size: cover;
  background-position: center;
  transition: opacity 0.6s ease;
`;

const Video = styled.video`
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: opacity 0.6s ease;
`;

const Overlay = styled.div`
  position: absolute;
  inset: 0;
  background: radial-gradient(
    ellipse at center,
    rgba(0, 0, 0, 0.1),
    rgba(0, 0, 0, 0.85)
  );
`;

const Content = styled(motion.div)`
  position: absolute;
  left: 48px;
  bottom: 48px;
  max-width: 420px;
  color: #fff;
  @media (max-width: 780px) {
    width: 100%;
    padding: 0 1rem;
    left: 0;
    bottom: 60px;
  }
`;

const Title = styled.h2`
  font-size: var(--Normal-Heading-Font_Size);
  letter-spacing: 4px;
  margin-bottom: 12px;
  font-family:var(--Heading-Font) !important;
`;

const Desc = styled.p`
  font-size: 14px;
  line-height: 1.6;
  opacity: 0.85;
    display: -webkit-box;
  -webkit-line-clamp: 2; 
  -webkit-box-orient: vertical;
   overflow: hidden;
  text-overflow: ellipsis;
`;

const Explore = styled.div`
  position: absolute;
  right: 48px;
  bottom: 48px;
  color: #fff;
  font-size: 14px;
  letter-spacing: 1px;
  cursor: pointer;
`;
